function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo } from 'react';
import classNames from 'classnames';
const Icon = /*#__PURE__*/memo(({
  type,
  name,
  size,
  style,
  color,
  className,
  spin,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("i", _extends({
    className: classNames(`${type} fa-${name}`, {
      'fa-spin': spin
    }, className),
    style: { ...style,
      fontSize: size && `${size}px`,
      color
    }
  }, props));
});
Icon.defaultProps = {
  type: 'fa'
};
export default Icon;